import { FC, useState } from 'react';
import { InputSearch } from 'ui/inputs';
import { Add24 } from 'ui/icons';
import { Tooltip } from 'ui/tooltip';
import { BUTTON_VARIANTS, BUTTON_SIZES } from 'ui/button';
import { Body1 } from 'ui/theme';
import { useAssetManagerContext } from '../contexts/BaseAssetManagerContext';
import { AddAssetButton, AssetListWrapper } from './AssestManager.styled';

type AssetManagerSidebarListProps = {
  ListEntry: FC<React.PropsWithChildren<{ asset: any; onClick: () => void; className: string }>>;
};

export const AssetManagerSidebarList = ({ ListEntry }: AssetManagerSidebarListProps) => {
  const {
    assets,
    assetTypeName,
    selectedAssetId,
    changesMade,
    selectAssetInList,
    onSearch,
    createNew,
    setIsEditing,
  } = useAssetManagerContext();
  const [searchText, setSearchText] = useState<string>('');

  return (
    <AssetListWrapper data-test="asset-list">
      <InputSearch
        id="asset-list-search"
        value={searchText}
        placeholder={`Search ${assetTypeName ? `all ${assetTypeName.toLowerCase()}s` : ''}`}
        onChange={(search) => {
          setSearchText(search);
          onSearch(search);
        }}
      />
      <Tooltip isEnabled={changesMade} tooltipContent="Save to continue">
        <AddAssetButton
          data-test="asset-add-button"
          variant={BUTTON_VARIANTS.GHOST}
          size={BUTTON_SIZES.LARGE}
          onClick={() => !changesMade && createNew()}
          isDisabled={changesMade}
        >
          <Add24 isColorInherited />
          <Body1>{`Add ${assetTypeName || 'new'}`}</Body1>
        </AddAssetButton>
      </Tooltip>
      {assets.map((asset) => {
        const isDisabled = changesMade && asset.id !== selectedAssetId;
        return (
          <Tooltip key={asset.id} isEnabled={isDisabled} tooltipContent="Save to continue">
            <ListEntry
              asset={asset}
              onClick={() => {
                if (asset.id !== selectedAssetId && !changesMade) {
                  setIsEditing(false);
                  selectAssetInList(asset);
                }
              }}
              className={`${asset.id === selectedAssetId ? 'selected' : ''} ${
                isDisabled ? 'disabled' : ''
              }`}
            />
          </Tooltip>
        );
      })}
    </AssetListWrapper>
  );
};
